import { render, staticRenderFns } from "./AiKnowledge.vue?vue&type=template&id=5192383e&scoped=true"
import script from "./AiKnowledge.vue?vue&type=script&lang=js"
export * from "./AiKnowledge.vue?vue&type=script&lang=js"
import style0 from "./AiKnowledge.vue?vue&type=style&index=0&id=5192383e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5192383e",
  null
  
)

export default component.exports